
import axiosInstance from '@/lib/axios'; // Your configured axiosInstance instance




export async function getRecommendedMatches() {


    const response = await axiosInstance.get('/match/recommended_matches');

    return response.data;

}




export async function leaderLeaveLobby(match_id) {
    const response = await axiosInstance.delete(`/match/lobby/members/leave/owner/${match_id}`);
    return response.data;
}